import { Component, Input } from '@angular/core';
import { BlogArticleDetail } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-blog-article-ui-preview',
  templateUrl: './blog-article-ui-preview.component.html',
  styleUrls: ['./blog-article-ui-preview.component.scss'],
  standalone: false
})
export class BlogArticleUiPreviewComponent {
  @Input() public articlePreview!: BlogArticleDetail;

  public get previewExcerpt(): string {
    if (!this.articlePreview?.perex) {
      return '';
    }
    return this.articlePreview.perex.substring(0, 75) + '...';
  }
}
